import { OPEN_MODAL, CLOSE_MODAL } from './modal-actions';

export const defaultState = {
    modalData: [],
    useNewModal: false
};

/**
 * Modal Reducer
 *
 * Consumes OPEN_MODAL action
 * Consumes CLOSE_MODAL action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of modals to display
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case OPEN_MODAL:
        return {
            ...state,
            modalData: [
                ...state.modalData,
                {
                    id: state.modalData.length,
                    title: action.payload.title,
                    content: action.payload.content,
                    buttons: action.payload.buttons,
                    label: action.payload.label,
                    dateRange: action.payload.dateRange,
                    certificateType: action.payload.certificateType,
                    isDownloadCertificateType: action.payload.isDownloadCertificateType,
                    certificatesCount: action.payload.certificatesCount,
                    retrievedGems: action.payload.retrievedGems
                }],
            useNewModal: action.payload.useNewModal || false
        };

    case CLOSE_MODAL:
        return defaultState;

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./components/modal/modal-reducer.js